<div class="bg-accent-yellow_soft border border-accent-yellow rounded flex flex-col md:flex-row justify-start md:justify-center items-start md:items-center gap-6 md:gap-8 p-3 md:py-2.5 md:px-8"
    [ngClass]="{
    'relative z-10 mb-1': shouldStack(),
    'relative mb-4': !shouldStack()
    }">
    <div class="flex flex-col md:flex-row gap-2">
        <span class="text-base font-bold">{{ isFirstTime() ? 'Set your lending preferences.' : 'Time to Review Preferences.' }}</span>
        <span class="text-base">{{ isFirstTime() ? "Help us match your Credit Union with the right opportunities" : "Over 3 months have passed — make sure your choices are still up to date" }}</span>
    </div>
    <div class="flex items-center gap-3">
        <button class="bg-brand-gray_dark rounded px-2 py-1 text-white whitespace-nowrap"
            routerLink="/settings/lending-preferences">{{ isFirstTime() ? 'Set Preferences' : 'Review now'
            }}</button>
        <span class="text-sm cursor-pointer whitespace-nowrap" (click)="remindMeLater()">Remind me later</span>
    </div>
</div>